import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import { useState } from 'react';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

export default function Sec1({ label, title, desc, img, youtube, link }: any) {
    const { t } = useLang('ces2025');
    const [show, setShow] = useState(false);

    const handleClick = () => {
        if (youtube) {
            setShow(true);
            gtm.push({
                event: 'uaEvent',
                event_name: 'video',
                title_name: "EcoFlow DELTA 3 Plus: World's Fastest Charging Power Certifed by SGS", // 固定传值
                position: 'ces 2025_2',
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: 'Product Preview',
                product_name: title,
                button_name: t('F_btn'),
            });
        }
    };

    return (
        <section className="frag">
            <EfImg pc={img.pc} h5={img.h5} />
            <div className="info">
                {label && <p className="label">{label}</p>}
                {title && <p className="title">{title}</p>}
                {desc && <p className="desc">{desc}</p>}
                {youtube && (
                    <button className="btn video" onClick={handleClick}>
                        <span>{t('F_video')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.7926 13.7581L13.4382 10.4054C13.7147 10.2059 13.7147 9.79413 13.4382 9.59456L8.7926 6.24188C8.46192 6.00324 8 6.23952 8 6.64733V13.3527C8 13.7605 8.46192 13.9968 8.7926 13.7581Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                )}
                {link && (
                    <EfLink className="btn link" href={link} onClick={handleClick}>
                        {t('F_btn')}
                    </EfLink>
                )}
            </div>
            {show && <EfDialogYoutube open={show} src={youtube} callback={() => setShow(false)} />}
        </section>
    );
}
